import { Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../i18n/language.service';
import { I18N } from './boolean.i18n';

/**
 * Eine Pipe-Implementierung, die stellen benutzerfreundliche boolesche Werte dar.
 *
 * true/false -> Ja/Nein
 */
@Pipe({
    name: 'boolean'
})
export class BooleanPipe implements PipeTransform {

    i18n: any;

    languageSubscription: Subscription;

    constructor(private languageService: LanguageService) {
        this.languageSubscription = languageService.registerForLanguageChanged(this, 'i18n', I18N);
    }

    transform(value: boolean | string) {
        if (value === 'false' || value === false) {
            return this.i18n['false'];
        }
        if (value === 'true' || value === true) {
            return this.i18n['true'];
        }
        return value;
    }
}
